import { isDefined } from '@aloft/toolkit-shared';
import { Typography } from '@aloft/toolkit-sui';

import { FieldPath, useWatch } from 'react-hook-form';

import { selectEffectiveYear } from '../../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { PropertyGridForm } from '../../types.ts';
import { readOnlyFieldTypographyProps } from '../consts.ts';
import { PropertyGridFieldProps } from '../types.ts';

export const AgeWithYearBuiltReadOnlyField = ({
  columnIndex,
  field,
  colSpan = 1,
  control,
}: PropertyGridFieldProps) => {
  const { fieldName } = field;
  const effectiveYear = useAppSelector(selectEffectiveYear);

  const propertyDataFieldName: FieldPath<PropertyGridForm> = `columns.${columnIndex}.propertyData.${fieldName}`;
  const rawValue = useWatch({ control, name: propertyDataFieldName }) as
    | string
    | number
    | undefined;

  let numericValue: number | undefined;
  if (isDefined(rawValue)) {
    numericValue = typeof rawValue === 'number' ? rawValue : parseInt(rawValue, 10);
  }

  let displayValue: string | undefined;
  if (isDefined(numericValue) && !Number.isNaN(numericValue)) {
    const yearBuilt = effectiveYear ? parseInt(effectiveYear, 10) - numericValue : undefined;
    const suffix = numericValue === 1 ? 'yr' : 'yrs';
    displayValue = yearBuilt
      ? `${numericValue} ${suffix} (${yearBuilt})`
      : `${numericValue} ${suffix}`;
  }

  return (
    <Typography
      {...readOnlyFieldTypographyProps}
      __dangerDoNotUseSx={{
        ...readOnlyFieldTypographyProps.__dangerDoNotUseSx,
        gridColumn: `span ${colSpan}`,
      }}
    >
      {displayValue}
    </Typography>
  );
};
